(function () {
'use strict';

/**
 * This directive is for making the right panel resizable for better accesibility
 *
 */
angular.module('GorillaBoy.directives')
.directive('gbSidebarResizingControl', ['$timeout', '$document', '$rootScope', 'localStorageService', gbSidebarResizingControl]);
function gbSidebarResizingControl($timeout, $document, $rootScope, localStorageService) {
    return {
        restrict: 'A',
        //template: '<div class="cls-gb-sidebar-resizing-control"></div>',
        link: gbSidebarResizingControlLinkFn
    };
    function gbSidebarResizingControlLinkFn($scope, $element, $attrs) {
        var MIN_WIDTH_FOR_RIGHT_PANEL = 350,
            DEFAULT_WIDTH_FOR_RIGHT_PANEL = 400,
            widthRestoredFromStorage = false,
            RIGHT_PANEL_WIDTH_SETTING = 'wd_right_panel_width_in_px',
            COLLAPSED_WIDTH_FOR_RIGHT_PANEL = 40,
            MAIN_CONTENT_IDENTIFIER = '.content.main';

        var prevGrabClientX = null,
            currentContainerWidth = null;

        if (!$scope.layout.resizableRightSidebar) {
            return;
        }

        //The expression must match the ngIf of resize control
        $scope.$watch('layout.showRightSidebar', function(newVal, oldVal) {
            if (newVal) {
                registerListener();
                restoreWidthFromStorage();
            } else {
                $("#right-sidebar").each(function() {
                    //this points to the DOM node
                    this.style.width = '';
                });
            }
        });

        //The level of permissions impacts the No. of right panel tabs, which impacts the tabcontainer width.
        $scope.$watch('permissonsLoaded', watcherForRestoringWidthFromStorage);

        $scope.$watch('layout.showFilterPanel', function(newVal, oldVal) {
            if (newVal !== oldVal) {
                restoreWidthFromStorage();
            }
        });

        //Also apply the new width the draft publishing component shows up
        $scope.$watch('showDraftPublishingComponent()', watcherForRestoringWidthFromStorage);

        function watcherForRestoringWidthFromStorage(newVal, oldVal) {

            if (newVal) {
                restoreWidthFromStorage();
            }
        }

        function restoreWidthFromStorage() {
            if ($scope.layout.showRightSidebar) {
                $timeout(function() {
                    var width = localStorageService.get(RIGHT_PANEL_WIDTH_SETTING);
                    if (width) {
                        //Convert to Number as we might concat it later.
                        width = parseInt(width, 10);
                    } else {
                        width = DEFAULT_WIDTH_FOR_RIGHT_PANEL;
                    }
                    applyNewWidth(width);
                }, 0, false);
            }
        }

        function applyNewWidth(width) {
            if (!width) {
                return;
            }
            $scope.layout.rightPanelWidth = width;
            if ($scope.showDraftPublishingComponent()) {
                $element.find('#feedback-container .feedback-submit').outerWidth(width);
            }
            $element.find('.tabcontainer').css('margin-left', ($scope.sidebar.selectedIndex) * (-$scope.layout.rightPanelWidth) + 'px');
            //apply the delta as #right bar width
            $element.find(".sidebar-panel").width(width);
            $element.find("#right-sidebar").width(width);

            //add extra 200px to make sure we don't run into layout issues in IE
            //IE has a requirement to have defined width (as a style or CSS rule) for .tabcontainer, otherwise activity tab doesn't work
            $element.find(".tabcontainer").outerWidth(width * Object.keys($scope.RIGHT_TABS).length + 200 );
        }

        function onMouseDown(evt) {
            //when resizing the right panel hide the .content.main window to have the mousemove events be triggered
            //otherwise, since that's an iframe, mousemove won't be triggered
            var $mainContent = angular.element(MAIN_CONTENT_IDENTIFIER);
            $mainContent.css("visibility", "hidden");

            //Do not allow the drag to be construed as text-selection. This will avoid blue text select colors
            //on the panel text
            $element.addClass("not-draggable");

            currentContainerWidth = parseInt(angular.element("#right-sidebar").width(), 10);

            prevGrabClientX = evt.clientX;
            $document.on('mousemove', mouseMoveHandler);
            $document.on('mouseup', mouseUpHandler);
        }

        function mouseMoveHandler(evt) {
            var delta = prevGrabClientX - evt.clientX,
                newWidth = currentContainerWidth + delta;

            newWidth = Math.min(newWidth, window.innerWidth * 0.4);

            //We have an upper bound of 40% of available window width.
            //https://sim.amazon.com/issues/WORKDOCS-6258
            newWidth = Math.max(newWidth, MIN_WIDTH_FOR_RIGHT_PANEL);
            applyNewWidth(newWidth);
        }

        function mouseUpHandler(evt) {
            localStorageService.set(RIGHT_PANEL_WIDTH_SETTING, $scope.layout.rightPanelWidth);
            $element.removeClass("not-draggable");
            angular.element(MAIN_CONTENT_IDENTIFIER).css("visibility", "visible");
            $document.off('mousemove', mouseMoveHandler);
            $document.off('mouseup', mouseUpHandler);
        }

        //Just in case we navigate away w/o mouseup
        $scope.$on("$destroy", function() {
            $document.off('mousemove', mouseMoveHandler);
            $document.off('mouseup', mouseUpHandler);
        });

        function registerListener() {
            $timeout(function() {
                $element.find(".sidebar-resize-control").on('mousedown', onMouseDown);
            }, 0, false);
        }
    }
}

}());